import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(https://readdy.ai/api/search-image?query=Dark%20moody%20abstract%20art%20with%20deep%20crimson%20red%20and%20black%20gradient%2C%20subtle%20Japanese%20ink%20wash%20texture%2C%20elegant%20atmospheric%20composition%2C%20minimal%20dark%20aesthetic%20with%20warm%20red%20accents%2C%20fine%20art%20quality%2C%20sophisticated%20adult%20mood%2C%20clean%20gradient%20with%20organic%20flowing%20shapes&width=1800&height=900&seq=hm-hero-bg&orientation=landscape)`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-background-50"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto text-center px-4 md:px-6">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-foreground-50 mb-4 md:mb-6 leading-tight">
          精选成人漫画
          <br />
          <span className="text-primary-500">高清流畅阅读</span>
        </h1>
        <p className="text-base md:text-lg text-foreground-300 max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed">
          汇聚海量精选h漫画资源，涵盖多种风格与题材。每日更新最新内容，<br className="hidden sm:block" />
          安全、便捷、私密地享受优质漫画阅读体验。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/all"
            className="bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3 rounded-md text-base font-medium transition-all duration-200 cursor-pointer whitespace-nowrap w-full sm:w-auto"
          >
            <i className="ri-book-read-line mr-2"></i>立即浏览
          </Link>
          <Link
            to="/about"
            className="border border-foreground-400/40 hover:border-primary-500 text-foreground-200 hover:text-primary-500 px-8 py-3 rounded-md text-base font-medium transition-all duration-200 cursor-pointer whitespace-nowrap w-full sm:w-auto"
          >
            了解更多
          </Link>
        </div>

        <div className="flex items-center justify-center gap-8 md:gap-12 mt-10 md:mt-12">
          {[
            { value: '10,000+', label: '漫画作品' },
            { value: '500,000+', label: '日活用户' },
            { value: '1亿+', label: '累计阅读' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-accent-500 font-heading">{stat.value}</p>
              <p className="text-xs md:text-sm text-foreground-500 mt-1">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}